import type { PublicUser } from "@maimu/contracts";
import { ref } from "vue";

const TOKEN_KEY = "maimu.token";
const USER_KEY = "maimu.user";

function readUser(): PublicUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PublicUser;
  } catch {
    return null;
  }
}

export const token = ref<string | null>(localStorage.getItem(TOKEN_KEY));
export const currentUser = ref<PublicUser | null>(readUser());

export function startSession(nextToken: string, user: PublicUser): void {
  token.value = nextToken;
  currentUser.value = user;
  localStorage.setItem(TOKEN_KEY, nextToken);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function endSession(): void {
  token.value = null;
  currentUser.value = null;
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
